import React from 'react';
import { Link, withRouter } from 'react-router-dom';

const checkHash = (hash, path) => hash.find(h => h === path);

const StaffMenu = ({ location }) => {
	const hash = location.hash.split('#');

	return (
		<div className="element-box" style={{ paddingBottom: 0 }}>
			<div className="os-tabs-controls" style={{ marginBottom: '1px !important' }}>
				<ul className="nav nav-tabs medium">
					<li className="nav-item">
						<Link
							to={`${location.pathname}#profile`}
							className={checkHash(hash, 'profile') || checkHash(hash, '') ? 'nav-link active show' : 'nav-link'}
						>
							Overview
						</Link>
					</li>
					<li className="nav-item">
						<Link to={`${location.pathname}#attendance`} className={checkHash(hash, 'attendance') ? 'nav-link active show' : 'nav-link'}>
							Attendance
						</Link>
					</li>
					<li className="nav-item">
						<Link
							to={`${location.pathname}#transactions`}
							className={checkHash(hash, 'transactions') ? 'nav-link active show' : 'nav-link'}
						>
							Transactions
						</Link>
					</li>
					<li className="nav-item">
						<Link to={`${location.pathname}#leave`} className={checkHash(hash, 'leave') ? 'nav-link active show' : 'nav-link'}>
							Leave
						</Link>
					</li>
					<li className="nav-item">
						<Link to={`${location.pathname}#appraisals`} className={checkHash(hash, 'appraisals') ? 'nav-link active show' : 'nav-link'}>
							Appraisals
						</Link>
					</li>
					{/* <li className="nav-item">
						<Link to={`${location.pathname}#payroll`} className={checkHash(hash, 'payroll') ? 'nav-link active show' : 'nav-link'}>
							Payroll
						</Link>
					</li> */}
				</ul>
			</div>
		</div>
	);
};

export default withRouter(StaffMenu);
